const typographySizes = {
  // Text sizes with mobile variants
  text: {
    tekstSize0: {
      size: { mobile: 1, desktop: 1.2 },
      lineHeight: 1,
    },
    tekstSize1: {
      size: { mobile: 1.2, desktop: 1.4 },
      lineHeight: 1.5,
    },
    tekstSize2: {
      size: { mobile: 1.4, desktop: 1.8 },
      lineHeight: 1.4,
    },
    tekstSize3: {
      size: { mobile: 1.8, desktop: 2.2 },
      lineHeight: 1.3,
    },
    tekstSize4: {
      size: { mobile: 1.8, desktop: 2.5 },
      lineHeight: 1.3,
    },
    tekstSize5: {
      size: { mobile: 2.2, desktop: 2.9 },
      lineHeight: 1,
    },
    tekstSize6: {
      size: { mobile: 2.9, desktop: 3.9 },
      lineHeight: 1,
    },
    tekstSize7: {
      size: { mobile: 3.9, desktop: 5.2 },
      lineHeight: 1,
    },
    tekstSize8: {
      size: { mobile: 6.1, desktop: 8.2 },
      lineHeight: 0.9,
    },
    tekstSize9: {
      size: { mobile: 3.4, desktop: 11 },
      lineHeight: 1,
    },
  },
};

export default typographySizes;
